<template lang="pug">
  #mental-wellness-article
    BLoading(:active="articleLoading" :is-full-page="true")
    #wellness-container(v-if="!articleLoading")
      .section.mb-0
        .companion-action-menu
          CompanionActionsMenu(:backButton="goBack")
        .companion-main-content
          CompanionContentCard(
            :title="article.Title"
            :backgroundColor="'#' + article.BackgroundColor"
            :heroImage="article.HeroImage"
            :tag="article.Tag"
            :duration="article.Duration"
            :content="article.Text")
      .horizontal-divider(v-if="!articleLoading")
      .section.companion-sub-content(v-if="!articleLoading")
          WtTile.is-flex.is-flex-direction-column
              .column.is-12.custom-padding(v-if="havingRelatedGuides")
                  WtTitle.category-title Related guides
                  .guide-card-container
                      CompanionGuideCard.guide-card(
                        v-for="(guide, index) in article.RelatedGuides"
                        :key="index" :partNumber="guide.Number"
                        :previewImage="guide.PreviewImage"
                        :id="guide.GuideId"
                        :duration="guide.Duration"
                        :partTitle="guide.GuidePartTitle"
                        :partId="guide.GuidePartId"
                        :redirectTo="`/plan/guide/${guide.GuidePartId}`" )
              .column.is-12.pl-0.pr-0.pt-0(v-if="havingRelatedTopics")
                  WtTitle.category-title Related topics
                  .topic-card-container
                      CompanionTopicCard.topic-card(
                        v-for="(topic, index) in article.RelatedTopics"
                        :key="index" :previewImage="topic.PreviewImage"
                        :id="topic.Id" :partTitle="topic.Title"
                        :numberOfGuides="topic.NumberOfGuides"
                        :redirectTo="`/plan/topic/${topic.Id}`")
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import { mapActions, mapGetters } from "vuex";
import CompanionTopicCard from "@@/Companion/CompanionTopicCard";
import CompanionGuideCard from "@@/Companion/CompanionGuideCard";
import CompanionRightArrowCard from "@@/Companion/CompanionRightArrowCard";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import CompanionContentCard from "@@/Companion/CompanionContentCard";
import CompanionRatingCard from "@@/Companion/CompanionRatingCard";

export default {
  name: "CompanionArticle",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    CompanionTopicCard,
    CompanionGuideCard,
    CompanionRightArrowCard,
    CompanionActionsMenu,
    CompanionContentCard,
    CompanionRatingCard
  },
  mixins: [analyticsTrackingMixin],
  data() {
    return {
      article: {},
      articleLoading: true
    };
  },
  computed: {
    ...mapGetters("companion", ["getArticleById"]),
    havingRelatedGuides() {
      return (
        this.article?.RelatedGuides && this.article.RelatedGuides.length > 0
      );
    },

    havingRelatedTopics() {
      return (
        this.article?.RelatedTopics && this.article.RelatedTopics.length > 0
      );
    },

    havingRelatedStrategies() {
      return (
        this.article?.RelatedStrategies &&
        this.article.RelatedStrategies.length > 0
      );
    }
  },
  async mounted() {
    try {
      this.trackFeatureView("learn", "learn_article");
      const articleId = this.$route.params.articleId;
      let response = this.getArticleById(articleId);
      if (
        Object.keys(response).length === 0 ||
        Object.keys(response.data).length === 0
      ) {
        response = await this.fetchArticle({
          articleId: articleId
        });
      }
      this.articleLoading = false;
      this.article = response.data;
    } catch (e) {
      this.articleLoading = false;
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: e.message
      });
    }
  },
  methods: {
    ...mapActions("companion", ["fetchArticle"]),
    ...mapActions(["snackBar"]),
    goBack() {
      window.history.back();
    }
  }
};
</script>

<style scoped>
#mental-wellness-article {
  min-height: 100%;
  margin: auto;
  max-width: 718px;
}

#wellness-container {
  max-width: 100%;
  min-height: 100%;
  border-radius: 12px !important;
  background-color: white;
}

.section {
  padding: 24px 24px 24px 24px;
}

.horizontal-divider {
  height: 1px;
  margin: 0px !important;
}

.companion-sub-content {
  background-color: #fbfbfb;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 32px 24px 32px 24px;
}
.guide-card-container {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 8px !important;
}

.guide-card-container::-webkit-scrollbar {
  display: none;
}

.guide-card {
  width: 334px;
  height: 156px;
}

.topic-card-container {
  display: flex;
  scrollbar-width: none;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 8px !important;
}

.topic-card-container::-webkit-scrollbar {
  display: none;
}
.topic-card {
  margin: 0rem !important;
  width: 100% !important;
}

.category-title {
  font-family: Manrope;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  color: #1b1d20;
  padding: 0px;
  margin-bottom: 1rem !important;
}
.title:not(:last-child) {
  margin-bottom: 0rem;
}
.custom-padding {
  padding: 0rem 0rem 1.5rem 0rem !important;
}

@media (max-width: 768px) {
  #mental-wellness-article {
    max-width: 95%;
  }

  .guide-card-container {
    gap: 8px !important;
  }
  .guide-card {
    width: calc(50% - 0.75rem);
  }
  .category-title {
    width: 100%;
  }
  .topic-card-container {
    gap: 8px !important;
  }
  .topic-card {
    max-width: calc(50% - 0.75rem);
  }
}
@media (max-width: 480px) {
  #mental-wellness-article {
    max-width: 100%;
  }

  .guide-card-container {
    flex-wrap: wrap;
    gap: 16px !important;
  }
  .guide-card-container .guide-card {
    max-width: 100%;
  }
  .topic-card-container .topic-card {
    max-width: 100%;
  }
}
</style>
